import { render, staticRenderFns } from "./handleAlarm.vue?vue&type=template&id=5dadaff2"
import script from "./handleAlarm.vue?vue&type=script&lang=js"
export * from "./handleAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports